import { Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import hocFrom from "../../components/forms/HocFrom";
import Loader from "../../components/layout/Loader";

const FormConsultationRequest = ({
    handelUpdataFrom,
    handelSend,
    loding,
    handelLoadingform,
    LoadingForm,
    dataUpdate,
    handelsetdataForm,
    formdata,
}) => {
    const handelValue = (name, value) => {
        switch (name) {
            case "id":
                handelsetdataForm({ ...formdata, id: value });
                break;
            case "description":
                handelsetdataForm({ ...formdata, description: value });
                break;
        }
    };

    const handelSubmit = (event) => {
        event.preventDefault();
        handelLoadingform(true);

        if (!formdata.description) {
            toast.error("لطفا توضیحات پیگیری را وارد کنید را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false);
        } else {
            handelUpdataFrom()
        }
    };

    return (
        <>
            {loding ? (
                <Loader />
            ) : (
                <Form>
                    <Form.Row>
                    <Col md={4}>
                            <span>نام نام خانوادگی : </span> <span>{dataUpdate.firstName} {dataUpdate.lastName}</span>
                        </Col>
                        <Col md={4}>
                            <span>شماره موبایل : </span> <span>{dataUpdate.phoneNumber}</span>
                        </Col>

                        <Col md={4}>
                            <span>نوع درخواست مشاوره : </span> <span>{dataUpdate.typeTitle}</span>
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <hr />
                    </Form.Row>
                    <Form.Row>
                        
                        <Col>
                            <div className="form-group">
                                <label htmlFor="description">توضیحات پیگیری</label>
                                <textarea className="form-control" id="description"
                                    rows="6" defaultValue={dataUpdate.description}
                                    onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                            </div>
                        </Col>

                    </Form.Row>

                    <Form.Row>
                        <Col>
                            <button
                                type="submit"
                                className="btn btn-success"
                                onClick={handelSubmit}
                                disabled={LoadingForm}
                            >
                                {LoadingForm ? (
                                    <i className="fa fa-spinner fa-pulse fa-fw"></i>
                                ) : "ثبت پیگیری"}
                            </button>
                        </Col>
                    </Form.Row>
                </Form>
            )
            }
        </>
    );
}

export default hocFrom(FormConsultationRequest);
